import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Typography,
  Divider,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  TextField,
  CardContent,
  Card,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { FormBuilderRepository } from "./FornBuilderRepository";
import { MunicipalitiesRepository } from "../configuration/municipalities/MunicipalitiesRepository";
import { SchoolsRepository } from "../configuration/schools/SchoolsRepository";
import { UsersRepository } from "../administration/users/UsersRepository";

export default function FormBuilderPreview(props) {
  const [customForm, setCustomForm] = React.useState({
    name: "",
    description: "",
    formDefinition: "",
  });
  const [json, setJson] = React.useState([
    {
      component: {
        type: "div",
        defaultValue: "div",
        variant: "div",
      },
    },
  ]);
  const [rerender, triggerRerender] = React.useState(false);
  const [propUploadAcceptedFiles, setPropUploadAcceptedFiles] = React.useState([
    ".docx",
    ".pdf",
  ]);

  const [formData, setFormData] = React.useState({
    // form1name: "yeees",
    // Name: "Sale",
    // Surname: "mangup",
    // Email: "angelovski.sashe1@gmail.com",
    // Telephone: "070323839",
    attachments: {},
  });
  const [files, setFiles] = React.useState([]);
  const [municipalities, setMunicipalities] = React.useState();
  const [schools, setSchools] = React.useState();

  React.useEffect(() => {
    UsersRepository.fetchCurrentUserDetails().then((res) => {});
    if (props.id !== undefined) {
      FormBuilderRepository.findById(props.id).then(
        (res) => {
          setCustomForm(res.data);
          setJson(JSON.parse(res.data.formDefinition));
        },
        (err) => {}
      );
    }
    MunicipalitiesRepository.fetchAllMunicipalities({
      page: 0,
      size: 100,
      orderBy: "name",
      orderDirection: "ASC",
    })
      .then((res) => {
        setMunicipalities(res.data.content);
      })
      .catch((err) => {});
  }, []);

  React.useEffect(() => {}, [rerender]);

  const createdFormActions = {
    handleSubmit() {},
    onFieldChange: function (name, event) {
      if (name.includes("Municipa")) {
        SchoolsRepository.fetchAllSchoolsByMunicipality({
          municipalityId: event.target.value,
        }).then(
          (res) => {
            setSchools(res.data);
          },
          (err) => {}
        );
      }
      var tmpFormData = formData;
      tmpFormData[name] = event.target.value;
      setFormData(tmpFormData);
      triggerRerender(!rerender);
    },
    onAttachmentChange: function (id, name, event) {
      var tmpFormData = formData;
      tmpFormData.attachments[id][name] = event.target.value;
      setFormData(tmpFormData);
      triggerRerender(!rerender);
    },
    uploadFile: function (maxPoints, defaultPoints, name, files) {
      var tmpFormData = formData;
      if (tmpFormData.attachments == undefined) {
        tmpFormData.attachments = {};
      }
      tmpFormData.attachments[name] = {
        userComment: "",
        commisionComment: "",
        points: defaultPoints,
        maxPoints: maxPoints,
      };
      setFormData(tmpFormData);
      setFiles(files);
    },
    hasRole: function (role) {
      var currentUser = JSON.parse(window.localStorage.getItem("currentUser"));
      for (var i = 0; i < currentUser.authorities.length; i++) {
        if (currentUser.authorities[i].authority == role) {
          return true;
        }
      }
    },
  };

  return (
    <div className="componentContainer">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper
            style={{
              textAlign: "center",
              alignItems: "center",
              flexDirection: "column",
              display: "flex",
              padding: "20px",
            }}
          >
            <Divider></Divider>
            {json.map((item, index) =>
              item?.component?.type == "Typography" ? (
                <Grid container key={index}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <Typography key={index} variant={item.component.variant}>
                      {item.component.name}
                    </Typography>
                  </Grid>
                </Grid>
              ) : item.component.type == "TextField" ? (
                <Grid container key={index}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <TextField
                      key={index}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id={item.component.value}
                      label={item.component?.name}
                      multiline
                      rowsMax="4"
                      required={item.component.required}
                      onChange={createdFormActions.onFieldChange.bind(
                        this,
                        item.component.name
                      )}
                      value={
                        formData[item?.component?.name]
                          ? formData[item?.component?.name]
                          : item.component.value
                      }
                    />
                  </Grid>
                </Grid>
              ) : item.component.type == "Button" ? (
                <Grid container key={index}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <Button
                      style={{ marginTop: "15px" }}
                      key={index}
                      onClick={
                        item.component.onClick
                          ? "handleSubmit" && createdFormActions.handleSubmit
                          : createdFormActions.handleSubmit
                      }
                      variant="contained"
                      color="primary"
                      fullWidth
                    >
                      {item.component.name}
                    </Button>
                  </Grid>
                </Grid>
              ) : item.component.type == "FileUpload" ? (
                <Grid container key={index}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <Card
                      style={{
                        marginTop: "20px",
                        border: "1px solid #efefef",
                      }}
                    >
                      <DropzoneArea
                        dropzoneText={item.component.name}
                        acceptedFiles={propUploadAcceptedFiles}
                        filesLimit={parseInt(item.component.filesLimit)}
                        useChipsForPreview={true}
                        onChange={createdFormActions.uploadFile.bind(
                          this,
                          item.component.maxPoints,
                          item.component.defaultPoints,
                          item.component.name
                        )}
                      />
                      <CardContent>
                        {item.component.userComment && (
                          <TextField
                            fullWidth
                            multiline
                            disabled={
                              !createdFormActions.hasRole("ROLE_TEACHER")
                            }
                            onChange={
                              formData.attachments[item.component.name] &&
                              createdFormActions.onAttachmentChange.bind(
                                this,
                                item.component.name,
                                "userComment"
                              )
                            }
                            rows={4}
                            value={
                              formData.attachments[item.component.name]
                                ?.userComment
                                ? formData.attachments[item.component.name]
                                    ?.userComment
                                : ""
                            }
                            label="Коментар на апликант"
                          ></TextField>
                        )}
                        {item.component.commisionComment && (
                          <TextField
                            fullWidth
                            multiline
                            disabled={
                              !createdFormActions.hasRole("ROLE_COMMISION")
                            }
                            onChange={
                              formData.attachments[item.component.name] &&
                              createdFormActions.onAttachmentChange.bind(
                                this,
                                item.component.name,
                                "commisionComment"
                              )
                            }
                            value={
                              formData.attachments[item.component.name]
                                ?.commisionComment
                                ? formData.attachments[item.component.name]
                                    ?.commisionComment
                                : ""
                            }
                            rows={4}
                            label="Коментар на комисија"
                          ></TextField>
                        )}
                        <TextField
                          label="Бодови"
                          type="number"
                          disabled={
                            !createdFormActions.hasRole("ROLE_COMMISION")
                          }
                          onChange={
                            formData.attachments[item.component.name] &&
                            createdFormActions.onAttachmentChange.bind(
                              this,
                              item.component.name,
                              "points"
                            )
                          }
                          value={
                            formData.attachments[item.component.name]?.points
                              ? formData.attachments[item.component.name]
                                  ?.points
                              : item.component.defaultPoints
                          }
                          style={{ float: "right" }}
                        ></TextField>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              ) : item.component.type == "DropdownList" ? (
                <Grid container key={index}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      style={{ marginTop: "15px" }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        {item.component.name}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={formData[item?.component?.name]}
                        onChange={createdFormActions.onFieldChange.bind(
                          this,
                          item.component.name
                        )}
                      >
                        {item.component.optionsType == "custom" &&
                          item.component.options?.map((element, index) => (
                            <MenuItem
                              key={index}
                              value={Object.keys(element)[0]}
                            >
                              {Object.values(element)[0]}
                            </MenuItem>
                          ))}
                        {item.component.optionsType == "municipalities" &&
                          municipalities?.map((element, index) => (
                            <MenuItem key={index} value={element.id}>
                              {element.name}
                            </MenuItem>
                          ))}
                        {item.component.optionsType == "schools" &&
                          schools?.map((element, index) => (
                            <MenuItem key={index} value={element.id}>
                              {element.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              ) : item.component.type == "div" ? (
                <div key={index}></div>
              ) : (
                <React.Fragment></React.Fragment>
              )
            )}
            <br />
            <Grid container>
              <Grid item xs={2}></Grid>
              <Grid item xs={1}>
                <Button
                  style={{ float: "left" }}
                  disabled={props.disablePrev}
                  onClick={() => props.onFormPrev(formData)}
                  variant="outlined"
                  color="primary"
                >
                  Previous
                </Button>
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={1}>
                <Button
                  style={{ float: "right" }}
                  onClick={() => props.onFormNext(formData)}
                  variant="contained"
                  color="primary"
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
